<span class="swatch-color" [class.selected]="active()">
  <span class="wrap">
    @let si = swatchImage();
    @if (si) {
      <img
        [ngSrc]="si"
        [alt]="altText()"
        class="img-fluid img-round"
        ngSrcset="18w, 32w"
        width="18"
        height="18"
      />
    } @else {
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" height="16" width="16" class="product-color" role="img" [attr.aria-label]="altText()">
        <defs>
          <linearGradient id="gradientDots" gradientTransform="rotate(45)">
            <stop offset="0%"  stop-color="#007dff"/>
            <stop offset="75%" stop-color="#92de00"/>
            <stop offset="100%" stop-color="#ff1d00"/>
          </linearGradient>
        </defs>
        <circle class="inner" cx="16" cy="16" r="14" stroke="#232021" [attr.fill]="(isColorful() || colorOption()?.swatchColor == undefined) ? 'url(#gradientDots)' : colorOption()?.swatchColor" />
      </svg>
    }
  </span>

</span>
